"use client";

import React, { useRef } from "react";
import "./style.css";
import Image from "next/image";
import Slider from "react-slick";
import { ProductDetailsResponse } from "@/types/product";
import ViewAllButton from "../view-all-button/ViewAllButton";
import { Typography } from "../typography";
import { BestSellingProductsSlider } from "./best-selling-products-slider";

export interface TopProductsResponse extends ProductDetailsResponse {
  quantity: string;
  discount: number;
}

interface BestSellingProductsProps {
  topProductsData: TopProductsResponse[];
}

const BestSellingProducts = ({ topProductsData }: BestSellingProductsProps) => {
  const sliderRef = useRef<Slider>(null);

  const handlePrevClick = () => {
    sliderRef.current?.slickPrev();
  };

  const handleNextClick = () => {
    sliderRef.current?.slickNext();
  };

  return (
    <div className="bg-pageBg">
      <div className="container px-4 mx-auto">
        <div className="flex justify-between my-6 items-center">
          <div className="w-full lg:w-auto">
            <Typography
              tag="h2"
              className="text-[1.5em] sm:text-[1.7em] text-left"
            >
              Best Selling Products
            </Typography>
          </div>
          <div className="flex gap-6 items-center">
            <div className="flex gap-2 sm:gap-4">
              <button
                onClick={handlePrevClick}
                className="transition-all rounded-full p-2 sm:p-3 border shadow border-primary hover:scale-105 hover:shadow-md active:scale-100"
              >
                <Image
                  src="/img/arrow-left-slide.svg"
                  alt="Previous"
                  width={20}
                  height={20}
                />
              </button>
              <button
                onClick={handleNextClick}
                className="transition-all rounded-full p-2 sm:p-3 border shadow border-primary hover:scale-105 hover:shadow-md active:scale-100"
              >
                <Image
                  src="/img/arrow-right-slide.svg"
                  alt="Next"
                  width={20}
                  height={20}
                />
              </button>
            </div>
            <div className="hidden lg:flex">
              <ViewAllButton />
            </div>
          </div>
        </div>
      </div>
      <div className="container px-4 lg:px-2 mb-8 pb-2 overflow-visible">
        <BestSellingProductsSlider
          data={topProductsData}
          sliderRef={sliderRef}
        />
      </div>
      <div className="lg:hidden flex items-center justify-center my-4">
        <ViewAllButton />
      </div>
    </div>
  );
};

export default BestSellingProducts;
